import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as flexBuyActionCreators from '@makemydeal/dr-dash-store/actions/flexBuyActionCreators';
import type { UpdateFlexBuyPaymentGridDataPayload } from '@makemydeal/dr-offer-redux';
import type { TermMonthItem } from '@makemydeal/dr-platform-types';
import type { FC } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlexBuyTermAndPercentInputs } from './FlexBuyTermAndPercentInputs';

type FlexBuyTermAndPercentRowProps = {
    isLoadingGrid?: boolean;
    flexBuyPaymentGridData: UpdateFlexBuyPaymentGridDataPayload | null;
};

export const FlexBuyTermAndPercentRow: FC<FlexBuyTermAndPercentRowProps> = ({ isLoadingGrid, flexBuyPaymentGridData }) => {
    const dispatch = useDispatch();
    const termsList = useSelector(offerReduxSelectors.getFlexBuyPaymentGridTermsList);
    const percentList = useSelector(offerReduxSelectors.getFlexBuyPaymentGridPercentsList);
    const flexBuyDownPaymentsList = useSelector(offerReduxSelectors.getFlexBuyPaymentGridCashDowns);
    const currentDownPayment = useSelector(offerReduxSelectors.getDownPayment) || 0;

    const paymentGridFlexBuyTermListRef = useRef<TermMonthItem[]>(termsList);
    const paymentGridFlexBuyPercentsListRef = useRef<TermMonthItem[]>(percentList);

    const handleChangeTerm = (term: TermMonthItem, percent: TermMonthItem) => {
        const newTermsList: TermMonthItem[] = paymentGridFlexBuyTermListRef.current.map((item, index) =>
            index === term.key ? { ...item, val: term.val } : item
        );
        const newPercentsList: TermMonthItem[] = paymentGridFlexBuyPercentsListRef.current.map((item, index) =>
            index === term.key ? { ...item, val: percent.val } : item
        );
        const columnIndex = term.key;
        paymentGridFlexBuyTermListRef.current = newTermsList;
        paymentGridFlexBuyPercentsListRef.current = newPercentsList;

        const hasSelectedItemInColumn = flexBuyPaymentGridData?.some((row) => row.items[columnIndex].isSelected) ?? false;

        dispatch(
            flexBuyActionCreators.thunkUpdateTermAndPercent({
                selectedTermItem: term,
                selectedPercentItem: percent,
                newTermsList,
                newPercentsList,
                flexBuyDownPaymentsList,
                currentDownPayment,
                columnIndex,
                hasSelectedItemInColumn
            })
        );
    };

    const handleChangeFlexBuyPercent = (percent: TermMonthItem) => {
        const newPercentsList: TermMonthItem[] = paymentGridFlexBuyPercentsListRef.current.map((item, index) =>
            index === percent.key ? { ...item, val: percent.val } : item
        );
        paymentGridFlexBuyPercentsListRef.current = newPercentsList;

        const newTermsList = paymentGridFlexBuyTermListRef.current;
        const columnIndex = percent.key;

        const hasSelectedItemInColumn = flexBuyPaymentGridData?.some((row) => row.items[columnIndex].isSelected) ?? false;

        dispatch(
            flexBuyActionCreators.thunkUpdateTermAndPercent({
                selectedPercentItem: percent,
                newPercentsList,
                flexBuyDownPaymentsList,
                newTermsList,
                currentDownPayment,
                columnIndex,
                hasSelectedItemInColumn
            })
        );
    };

    return (
        <>
            {termsList.map((term, key) => (
                <FlexBuyTermAndPercentInputs
                    key={`${term.key}-${term.val}`}
                    term={term}
                    flexBuyPercent={percentList[key]}
                    onChangeTerm={handleChangeTerm}
                    onChangeFlexBuyPercent={handleChangeFlexBuyPercent}
                    isLoadingGrid={isLoadingGrid}
                />
            ))}
        </>
    );
};
